import { defineComponent as _defineComponent } from 'vue'
import { Offer } from '@/@types/graphql-types';
import NewDesignModal from '@/components/modals/NewDesignModal.vue';
import { TitleDetail } from '@/interfaces/title-details-graphql';
import { computed } from 'vue';
import DailyMotionPlayer from '@/ui-components/DailyMotionPlayer.vue';
import BasicButton from './BasicButton.vue';
import { ModalHelper } from '@/helpers/modal-helper';
import { ProModal } from '@/lazy-load-components';
import { useExperiment } from '@/libraries/experiment';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { useLanguageStore } from '@/helpers/composables/useStores';
import { saveLastProView } from '@/helpers/pro-web-helper';

export default /*#__PURE__*/_defineComponent({
  __name: 'JwTVModal',
  props: {
    offer: null,
    title: { default: undefined }
  },
  setup(__props: any) {

const props = __props as { offer: Offer, title: TitleDetail };

const FreemiumFilterBadge = () =>
	import(/* webpackChunkName: "freemium-filter-badge" */ '@/components/filter-bar/FreemiumFilterBadge.vue');

const { language } = useLanguageStore();


const { activeVariant } = useExperiment('JUSTWATCH_TV_PRO_EXP', 'global');
const titleName = computed(() =>
	props.title?.__typename == 'Season' ? props.title?.show?.content.title : props.title?.content.title
);

const clip = computed(() => ({
	provider: 'JUSTWATCH_TV',
	externalId: props.offer.id,
	sourceUrl: props.offer.streamUrl as string,
}));

const logoSrc = computed(() => {
	const file = `JustWatch-logo-small`;
	return {
		png: `/${ASSETS_DIR}/img/logo/${file}.png`,
		webp: `/${ASSETS_DIR}/img/logo/${file}.webp`,
	};
});

const adFreeText = computed(() => {
	switch (language.value) {
		case 'ar':
			return 'شاهد هذا العنوان <strong>بدون إعلانات</strong> مع';
		case 'tr':
			return 'Bu içeriği<strong>reklamsız</strong> izle';
		case 'de':
			return 'Schau dir diesen Titel <strong>werbefrei</strong> mit';
		default:
			return 'Watch this title <strong>ad-free</strong> with';
	}
});

async function openPro() {
	await ModalHelper.close();

	TrackingHelper.trackEvent('userinteraction', {
		action: 'get_justwatch_pro_clicked',
	});

	const location = 'justwatchTvModal';
	saveLastProView(location);
	ModalHelper.openModal(
		ProModal,
		{},
		{
			cssClass: 'pro-jw-pro-modal',
		},
		location,
		true
	);
}

return { __sfc: true,FreemiumFilterBadge, language, props, activeVariant, titleName, clip, logoSrc, adFreeText, openPro, NewDesignModal, DailyMotionPlayer, BasicButton }
}

})